import type { Locale, Translation } from '@skytech/types'

import { countryIdByCountryName, COUNTRY_BY_LANG } from './constants'

export const LOCALES: Locale[] = [
  'nl',
  'fr',
  'es',
  'hu',
  'gb',
  'dk',
  'se',
  'no',
  'pl',
  'de',
  'ph',
  'fi',
  'lv',
  'ee',
  'en',
]
export const LOCALE_WITH_NAMES: Record<Locale, string> = {
  nl: 'Dutch',
  fr: 'French',
  es: 'Spanish',
  hu: 'Hungarian',
  gb: 'British English',
  dk: 'Danish',
  se: 'Swedish',
  no: 'Norwegian',
  pl: 'Polish',
  de: 'German',
  ph: 'Philippine',
  fi: 'Finnish',
  lv: 'Latvian',
  ee: 'Estonian',
  en: 'American English',
}

export const isLocale = (lang: string): lang is Locale => LOCALES.includes(lang as Locale)

export const checkLocaleAgainstTranslations = ({
  locale,
  translationList,
  defaultLocale,
}: {
  locale: string
  translationList: Record<Locale, Translation>
  defaultLocale: Locale
}) => {
  if (!isLocale(locale)) return defaultLocale

  return translationList?.[locale] ? locale : defaultLocale
}

export const getBrowserLocale = () => {
  let browserLocale = navigator.language.split(/[-_]/)[0]

  // To have all Norwegian translations under one key
  if (browserLocale === 'nb') browserLocale = 'no'
  if (browserLocale === 'sv') browserLocale = 'se'

  return browserLocale as Locale
}

export function getDefaultCountryId(locale: Locale) {
  const storedPhoneCountryId = localStorage.getItem('phoneCountryId')
  const defaultCountryBasedOnLocale = COUNTRY_BY_LANG[locale]
  const defaultCountryIdBasedOnLocale =
    (defaultCountryBasedOnLocale && countryIdByCountryName[defaultCountryBasedOnLocale]) ||
    countryIdByCountryName['Norway']

  const defaultPhoneCountryId = storedPhoneCountryId
    ? Number(storedPhoneCountryId)
    : defaultCountryIdBasedOnLocale

  if (!defaultPhoneCountryId) throw Error('Missing default country id!')

  return defaultPhoneCountryId
}
